import IReader from './IReader'
import WFSBean from '../beans/WFSBean'

export default class WFSReader extends IReader {
    constructor() {
        super(WFSBean)
    }

    /**
     * 读取wfs图层数据
     * @param {WFSBean} wfsBean
     */
    async _read(wfsBean) {
        const wfsQueryObj = new GeoGlobe.Query.WFSQuery(
            wfsBean.url,
            wfsBean.layerName,
            {
                geometryName: wfsBean.geometryName,
                version: '1.0.0',
                maxFeatures: wfsBean.maxFeatures
            }
        )
        return new Promise((resolve, reject) => {
            try {
                wfsQueryObj.query(
                    null,
                    ({ geojson }) => resolve(this.group(geojson.features)),
                    reject
                )
            } catch (error) {
                reject(error)
            }
        })
    }

    group(features) {
        const enums = this.newEmptyGroup()

        // 分组
        if (features.length > 0) {
            const type = features[0].geometry.type.toUpperCase()
            const ls = enums[type]
            ls && ls.push(...features)
        }

        // return
        return {
            geojson: features,
            group: enums.toObject()
        }
    }
}
